// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8299 ? "user-status-modal" : chunkId) + "-" + chunkId + ".js?v=" + {"6799":"00434e4baa0d8e7b79f1","8299":"3d7c84a277b700b090a4"}[chunkId] + "";
};